import qs from 'qs';

import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import messagingService from 'services/MessagingService/MessagingService';
import {
  ADD_BROADCASTER_TO_SPONSORED_TAG,
  ADD_BROADCASTER_TO_SPONSORED_TAG_ERROR,
  ADD_BROADCASTER_TO_SPONSORED_TAG_RESPONSE,
  ADD_STUDIO_BROADCASTERS_TO_SPONSORED_TAG,
  ADD_STUDIO_BROADCASTERS_TO_SPONSORED_TAG_ERROR,
  ADD_STUDIO_BROADCASTERS_TO_SPONSORED_TAG_RESPONSE,
  CHANGE_SPONSORED_TAG_SWITCH_STATUS,
  CHANGE_SPONSORED_TAG_SWITCH_STATUS_ERROR,
  CHANGE_SPONSORED_TAG_SWITCH_STATUS_RESPONSE,
  CREATE_SPONSORED_TAG,
  CREATE_SPONSORED_TAG_ERROR,
  CREATE_SPONSORED_TAG_RESPONSE,
  DELETE_SPONSORED_TAG,
  DELETE_SPONSORED_TAG_ERROR,
  DELETE_SPONSORED_TAG_RESPONSE,
  GET_BROADCASTERS_LIST_FOR_TAG,
  GET_BROADCASTERS_LIST_FOR_TAG_ERROR,
  GET_BROADCASTERS_LIST_FOR_TAG_RESPONSE,
  GET_SPONSORED_TAGS_LIST,
  GET_SPONSORED_TAGS_LIST_ERROR,
  GET_SPONSORED_TAGS_LIST_RESPONSE,
  PREDEFINED_TAGS_RESPONSE,
  REMOVE_BROADCASTER_USING_SPONSORED_TAG,
  REMOVE_BROADCASTER_USING_SPONSORED_TAG_ERROR,
  REMOVE_BROADCASTER_USING_SPONSORED_TAG_RESPONSE,
} from 'services/MessagingService/EventNames';
import parseCatch from 'utils/parseCatch';


const WEBCHAT_HOST = ConfigurationService.get(ConfigurationKeys.WEB_CHAT_HOST);
const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const SPONSORED_TAGS_URL = `${BASE_URL}/rest/v1.0/admin/tags`;
const PREDEFINED_TAGS_URL = `${BASE_URL}/rest/v1.0/predefined-tags`;
const UPDATE_BROADCAST_STATUS_URL = `${WEBCHAT_HOST}updateBroadcastStatus`;

class TagsService {
  constructor() {
    this.messagingService = messagingService();
    this.messagingService.on(GET_SPONSORED_TAGS_LIST, this.getSponsoredTagsList);
    this.messagingService.on(GET_BROADCASTERS_LIST_FOR_TAG, this.getBroadcastersList);
    this.messagingService.on(CHANGE_SPONSORED_TAG_SWITCH_STATUS, this.changeSponsoredTagSwitchValue);
    this.messagingService.on(CREATE_SPONSORED_TAG, this.createSponsoredTag);
    this.messagingService.on(REMOVE_BROADCASTER_USING_SPONSORED_TAG, this.removeBroadcasterUsingSponsoredTag);
    this.messagingService.on(ADD_BROADCASTER_TO_SPONSORED_TAG, this.addBroadcasterOrStudioToSponsoredTag);
    this.messagingService.on(ADD_STUDIO_BROADCASTERS_TO_SPONSORED_TAG, this.addBroadcasterOrStudioToSponsoredTag);
    this.messagingService.on(DELETE_SPONSORED_TAG, this.deleteSponsoredTag);
  }

  destructor() {
    this.messagingService.off(GET_SPONSORED_TAGS_LIST, this.getSponsoredTagsList);
    this.messagingService.off(GET_BROADCASTERS_LIST_FOR_TAG, this.getBroadcastersList);
    this.messagingService.off(CHANGE_SPONSORED_TAG_SWITCH_STATUS, this.changeSponsoredTagSwitchValue);
    this.messagingService.off(CREATE_SPONSORED_TAG, this.createSponsoredTag);
    this.messagingService.off(REMOVE_BROADCASTER_USING_SPONSORED_TAG, this.removeBroadcasterUsingSponsoredTag);
    this.messagingService.off(ADD_BROADCASTER_TO_SPONSORED_TAG, this.addBroadcasterOrStudioToSponsoredTag);
    this.messagingService.off(ADD_STUDIO_BROADCASTERS_TO_SPONSORED_TAG, this.addBroadcasterOrStudioToSponsoredTag);
    this.messagingService.off(DELETE_SPONSORED_TAG, this.deleteSponsoredTag);
  }

  getSponsoredTagsList = (payload) => {
    const GET_TAGS_URL =
      `${SPONSORED_TAGS_URL}?offset=${payload.offset}&limit=10&sortBy=CREATED_AT&sortDirection=${payload.direction}`;
    ApiService.get(GET_TAGS_URL)
      .then((response) => {
        this.messagingService.emit(GET_SPONSORED_TAGS_LIST_RESPONSE, response.data);
      })
      .catch((error) => {
        this.messagingService.emit(GET_SPONSORED_TAGS_LIST_ERROR, error.response);
      });
  };

  getBroadcastersList = (payload) => {
    // eslint-disable-next-line max-len
    const GET_BROADCASTERS_URL = `${SPONSORED_TAGS_URL}/${payload.tagId}/tags-users?offset=${payload.offset}&limit=20&sortBy=CREATED_AT&sortDirection=${payload.direction}`;
    ApiService.get(GET_BROADCASTERS_URL)
      .then((response) => {
        response.data.isStudio = payload.isStudio;
        this.messagingService.emit(GET_BROADCASTERS_LIST_FOR_TAG_RESPONSE, response.data);
      })
      .catch((error) => {
        this.messagingService.emit(GET_BROADCASTERS_LIST_FOR_TAG_ERROR, error.response);
      });
  };

  changeSponsoredTagSwitchValue = (data) => {
    const CHANGE_SWITCH_STATUS_URL = `${SPONSORED_TAGS_URL}/${data.id}`;
    ApiService.put(CHANGE_SWITCH_STATUS_URL, { data })
      .then(() => {
        this.messagingService.emit(CHANGE_SPONSORED_TAG_SWITCH_STATUS_RESPONSE);
      })
      .catch((error) => {
        const errorJSON = {
          type: 'TAG_SWITCH_VALUE',
          status: error.response,
        };
        this.messagingService.emit(CHANGE_SPONSORED_TAG_SWITCH_STATUS_ERROR, errorJSON);
      });
  };

  createSponsoredTag = (tagName) => {
    const data = {
      name: tagName,
      active: false,
      exclusive: true,
    };
    ApiService.post(SPONSORED_TAGS_URL, { data })
      .then((response) => {
        this.messagingService.emit(CREATE_SPONSORED_TAG_RESPONSE, response.data);
      })
      .catch((error) => {
        const errorJSON = {
          type: 'CREATE_TAG',
          status: error.response,
        };
        this.messagingService.emit(CREATE_SPONSORED_TAG_ERROR, errorJSON);
      });
  };

  removeBroadcasterUsingSponsoredTag = (data) => {
    const DELETE_BROADCASTER_URL = `${SPONSORED_TAGS_URL}/${data.tagId}/tags-users/${data.username}`;
    ApiService.delete(DELETE_BROADCASTER_URL)
      .then(() => {
        this.messagingService.emit(REMOVE_BROADCASTER_USING_SPONSORED_TAG_RESPONSE);
      })
      .catch((error) => {
        const errorJSON = {
          type: 'REMOVE_BROADCASTER_FROM_TAG',
          status: error.response,
        };
        this.messagingService.emit(REMOVE_BROADCASTER_USING_SPONSORED_TAG_ERROR, errorJSON);
      });
  };

  addBroadcasterOrStudioToSponsoredTag = (data) => {
    const ADD_BROADCASTER_TO_TAG_URL = `${SPONSORED_TAGS_URL}/${data.tagId}/tags-users`;

    let successMessageType = undefined;
    let errorMessageType = undefined;
    if (data.studio) {
      successMessageType = ADD_STUDIO_BROADCASTERS_TO_SPONSORED_TAG_RESPONSE;
      errorMessageType = ADD_STUDIO_BROADCASTERS_TO_SPONSORED_TAG_ERROR;
    } else {
      successMessageType = ADD_BROADCASTER_TO_SPONSORED_TAG_RESPONSE;
      errorMessageType = ADD_BROADCASTER_TO_SPONSORED_TAG_ERROR;
    }

    const errorJSON = data.studio ? { type: 'ADD_STUDIO_BROADCASTERS' } : { type: 'ADD_BROADCASTER' };

    ApiService.post(ADD_BROADCASTER_TO_TAG_URL, { data: { username: data.username, studio: data.studio } })
      .then(() => {
        this.messagingService.emit(successMessageType, data.studio);
      })
      .catch((error) => {
        if (error.response && typeof error.response.status !== 'undefined') {
          errorJSON.status = error.response.status;
          errorJSON.message = error.response.data.message;
          errorJSON.code = error.response.data.code;
        } else {
          errorJSON.status = undefined;
        }
        this.messagingService.emit(errorMessageType, errorJSON);
      });
  };

  deleteSponsoredTag = (tagId) => {
    const DELETE_SPONSORED_TAG_URL = `${SPONSORED_TAGS_URL}/${tagId}`;
    ApiService.delete(DELETE_SPONSORED_TAG_URL)
      .then(() => {
        this.messagingService.emit(DELETE_SPONSORED_TAG_RESPONSE);
      })
      .catch((error) => {
        const errorJSON = {
          type: 'DELETE_TAG',
          status: error.response,
        };
        this.messagingService.emit(DELETE_SPONSORED_TAG_ERROR, errorJSON);
      });
  };

  getPredefinedTags = (username, accessHash) => {
    const params = {
      username,
      accessHash,
    };
    ApiService.get(encodeURI(PREDEFINED_TAGS_URL), { params })
      .then((res) => {
        this.messagingService.emit(PREDEFINED_TAGS_RESPONSE, res.data);
      })
      .catch((error) => {
        parseCatch(error);
      });
  };

  /**
   * Method for updating broadcast tags
   * @param {string} username
   * @param {string} accessHash
   * @param {string} tags
   */
  updatePredefinedTags = (username, accessHash, tags) => {
    const data = {
      status: tags,
      accessHash,
      username,
      roomname: username,
    };

    ApiService.post(UPDATE_BROADCAST_STATUS_URL, {
      data: qs.stringify(data),
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    }).catch((error) => parseCatch(error));
  };
}

export default new TagsService();
